__turbopack_context__.v({
  "awards-list": "CoreCredentials-module-scss-module__l2kwfG__awards-list",
  "education-item": "CoreCredentials-module-scss-module__l2kwfG__education-item",
  "education-label": "CoreCredentials-module-scss-module__l2kwfG__education-label",
  "education-subhead": "CoreCredentials-module-scss-module__l2kwfG__education-subhead",
  "grid": "CoreCredentials-module-scss-module__l2kwfG__grid",
  "pdf": "CoreCredentials-module-scss-module__l2kwfG__pdf",
});
